import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/svg/dproxy-price.svg'


const _hoisted_1 = { class: "col-lg-4 col-md-3 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = {
  style: {"margin-bottom":"5px"},
  id: "bwtotal"
}
const _hoisted_5 = {
  class: "pricing-amount",
  style: {"padding-top":"0"}
}
const _hoisted_6 = { class: "monthly_price" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "$")
], -1)
const _hoisted_8 = {
  class: "price",
  id: "bwprice"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { style: {"text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "$1.30/proxy/month"),
  /*#__PURE__*/_createElementVNode("li", null, "Unlimited bandwidth."),
  /*#__PURE__*/_createElementVNode("li", null, "HTTP/s & Socks4/5 proxies."),
  /*#__PURE__*/_createElementVNode("li", null, "No rate limit*")
], -1)
const _hoisted_10 = { class: "pricing-content" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Purchase")



// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  props: {
  card: Object,
},
  setup(__props) {

const { card } = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.card.name) + " dedicated proxies", 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.card.price), 1)
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "pricing-btn blue-btn",
          to: `/purchase?type=beta_new_dedicated&proxies=${__props.card.name}`
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})